import instance from '../xhrService';

export interface Tenant {
    tenantDetails: any,
    subscriptionId: number,
    userEmail: string
    selectedAddOns: any
}

const tenantSetupApi = {

    create(body: Tenant): Promise<any> {
        return instance.post(`/api/createNewTenantWithSubscription`, body).then((res) => res.data);
    },
};

export default tenantSetupApi;
